/* RESPONSIBLE TEAM: team-frontend-tech */
import { and } from '@ember/object/computed';
import Predicate from 'predicates/models/predicate';
export default Predicate.extend({
  isEditable: true,
  isBooleanType: true,
  genericType: 'boolean',
  isValid: and('hasAttributeComparisonAndType', 'hasNoValue'),
  defaultComparison: 'true',
  getDefaultValue() {
    return null;
  }
});